import React, { Component } from 'react';
import Icon from '../../icons';

class Select extends Component {
    dropDownRef;
    selectedRef;
    menuRef;
    state = {
        isOpen: false,
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.onClickOutsideSelect);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onClickOutsideSelect);
    }

    onClickOutsideSelect = (e) => {
        if (this.dropDownRef && !this.dropDownRef.contains(e.target)) {
            this.closeDropDown();
        }
    }

    openDropDown = () => {
        this.setState({
            isOpen: true
        },() =>{
            if(this.menuRef.scrollTop === 0){
                setTimeout(() => {
                    if(this.selectedRef && this.menuRef){
                        this.menuRef.scrollTop = this.selectedRef.getBoundingClientRect().top - this.menuRef.getBoundingClientRect().top
                    }
                }, 200);
            }
        })
    }

    closeDropDown = () => {
        this.setState({
            isOpen: false
        })
    }

    onSelect = (e, option) => {
        if(!option.disabled) {
            if(this.props.selected !== option.value) {
                this.props.onSelect(option.value);
            }
            this.closeDropDown();
        }
    }

    render() {
        const { options, iconName, openOnHover, openOnClick, title, styleClass, widthClass,template } = this.props;
        const selected =  options!=undefined&& options.find(option => option.value == this.props.selected);

        return (
            <div ref={(node) => { this.dropDownRef = node }} className={`dropDown select ${styleClass}`}
                onMouseLeave={openOnHover ? this.closeDropDown : () => {}}
            >
                <div className="alignMiddle rowSpaceBetween flexGrow"
                    onClick={openOnClick ? (this.state.isOpen ? this.closeDropDown : this.openDropDown) : () => {}}
                    onMouseOver={openOnHover ? this.openDropDown : () => {}}
                >
                    { title ? 
                        <span>{title}</span> : 
                        selected && <span>{selected.label}</span>
                    }
                    { iconName && <Icon name={iconName} className="icon ml select" />}
                </div>
                <div ref={(node) => { this.menuRef = node }} className={`dropDownMenu inProgress ${this.props.className} ${this.props.isOpenRight ? 'openRight' :''} openTop ${this.state.isOpen ? "onClick" : ''} ${widthClass}`} >
                    {options && options.map((option, index) => (
                        <span
                            ref={(node) => { if(selected && option.value === selected.value) this.selectedRef = node}} 
                            onClick={(e) => { this.onSelect(e, option) }} 
                            key={index}
                        >
                            <a className={`pointer ${(selected && selected.value == option.value) ?'active': ''}`} 
                                >{option.label} {(selected && !option.disabled && option.value === selected.value) && <span className="badges checked selectChecked green"></span>}
                                </a>
                        </span>
                    ))}
                    { template ? template : null}
                </div>
            </div>
        )
    }
}

export default Select;